import script from "./SubscriptionEnd.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubscriptionEnd.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__